import { useContext, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import Pagination from "pages/Pagination";
import IncomingTable from "./IncomingTable";
import OSearch from "components/reusable/OSearch";
import { useTranslation } from "react-i18next";
import OngoingTable from './OngoingTable'
import RejectedTable from './RejectedTable'
import CompletedTable from './CompletedTable'
import dayjs from "dayjs";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import helpers from "utils/helpers";
import AuthContext from "context/AuthContext";
import ODateRangePicker from "components/shared/datePicker/ODateRangePicker";
import { BiReset, BiSolidFileExport } from "react-icons/bi";
import { useNavigate, useSearchParams } from "react-router-dom";


const tabs = [
  { name: "Incoming Services", value: 'pending' },
  { name: "Accepted Request", value: 'accepted' },
  { name: "Ongoing Services", value: 'ongoing' },
  { name: "Scheduled Services", value: 'schedule' },
  { name: "Cancelled Services", value: 'cancelled' },
  { name: "Cancelled Services (By Driver)", value: 'cancelledByDriver' },
  { name: "Completed Services", value: 'completed' },
];



export default function ServiceRequests() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  const tab = searchParams.get("tab");
  const [activeTab, setActiveTab] = useState(tab||"pending");
  const childRef = useRef();
  const { updatePageName } = useContext(AuthContext);
  const { t } = useTranslation();


  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });

  const [filterData, setFilterData] = useState({
    category: "foreignTourist",
    searchkey: "",
    startDate: "",
    endDate: "",
    bookingType: "",
    isReset: false,
    isFilter: false,
  });
  const [requestData, setRequestData] = useState([])
  console.log(requestData, "requestData");


  const [searchTerm, setSearchTerm] = useState("");
  const [isInitialized, setIsInitialized] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };




  const getAllRequest = async (data) => {
    try {
      const { startDate, endDate, searchKey, bookingType } = filterData;
      const payload = {
        page,
        pageSize,
        bookingType,
        startDate: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        endDate: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: helpers.normalizeSpaces(searchKey) || null,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        status: helpers.ternaryCondition(activeTab === "ongoing", ["inProgress"], [activeTab]),
        timezone: new Date().getTimezoneOffset(),

      };
      const path =activeTab!=='cancelledByDriver'?apiPath.getRequestList:apiPath.getRequestList+'/cancelled-by-driver-requests';
      const result = await apiGet(path, payload);
      const responseData = result?.data?.results?.docs;
      const resultStatus = result?.data?.success;
      if (data == "export") {
        helpers.downloadFile(result?.data?.results?.csvFilePath);
      } else {
        setRequestData(responseData);
      }
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? result?.data?.results.page : null,
        pageCount: resultStatus ? result?.data?.results.totalPages : null,
        perPageItem: resultStatus ? responseData?.length : null,
        totalItems: resultStatus ? result?.data?.results.totalDocs : null,
      });
    } catch (error) {
      console.error("error in get all sub admin list==>>>>", error.message);
    }
  };
  useEffect(() => {
    getAllRequest();
    setRequestData([])
    localStorage.setItem('activeTab',activeTab)
  }, [filterData, page, pageSize, sort, activeTab]);


  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };


  const handleReset = () => {
    setFilterData({
      category: "",
      startDate: "",
      searchKey: "",
      endDate: "",
      bookingType: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setSearchTerm("");
    setPageSize(10);
    childRef?.current?.onClose();
  };


  useEffect(() => {
    if (!isInitialized) {
      setIsInitialized(true);
    } else if (searchTerm || !filterData?.isReset) {

      setFilterData({
        ...filterData,
        isReset: false,
        searchKey: debouncedSearchTerm || "",
        isFilter: !!debouncedSearchTerm,
      });
      setPage(1);
    }
  }, [debouncedSearchTerm]);



  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchTerm]);

  useEffect(() => {
    updatePageName(t("SERVICE_MANAGER"));
  }, []);

  const statusPageRole = (e) => {
    setPage(1);
    setFilterData({
      ...filterData,
      isReset: false,
      bookingType: e.target.value,
      isFilter: true,
    });
  };

  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      <div className="relative flex gap-2 sm:gap-3 mb-6 overflow-x-auto">
        {tabs?.map((tab) => (
          <button
            key={tab?.value}
            onClick={() => {
              setPage(1);
              navigate(`/service-monitoring?tab=${tab?.value}`,{ replace: true,})
              setFilterData({
                ...filterData,
                startDate: "",
                endDate: "",
              });
              setSearchTerm("");
              setActiveTab(tab?.value);
            }}
            className={`relative px-5 py-2 rounded-xl text-sm  transition-all duration-200
      ${activeTab === tab?.value
                ? "bg-black text-white shadow-md"
                : "bg-gray-100 text-gray-700 hover:bg-black hover:text-white"
              }
    `}
          >
            {tab?.name}

            {activeTab === tab?.value && (
              <motion.div layoutId="tab-indicator" />
            )}
          </button>
        ))}


        <div>
          {requestData?.length > 0 && activeTab == "completed" && (
            <button
              type="button"
              title={t("EXPORT_CSV")}
              className="bg-gradientTo text-sm flex gap-2 px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto "
              onClick={() => getAllRequest("export")}
            >
              <BiSolidFileExport size={18} />
              {t("EXPORT_CSV")}
            </button>
          )}
        </div>
      </div>

      <div className="bg-white shadow-md rounded-2xl p-4 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-4">
          <div className="flex flex-col sm:flex-row gap-2 sm:items-center">

            <div className="relative flex items-center mb-3">
              <OSearch
                placeholders={t(getSearchPlaceholder(activeTab))}
                onChange={(e) => {
                  setSearchTerm(e?.target?.value);
                }}
                className="w-[340px] h-[38px] rounded-lg"
                ref={childRef}
              />

            </div>

            <ODateRangePicker
              handleDateChange={handleDateChange}
              filterData={filterData}
              isReset={filterData?.isReset}
              setIsReset={setFilterData}
            />
            <span className="flex items-center ml-3 mb-3">
              <select
                id=""
                type="text "
                name="bookingType"
                className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 dark:border-[#fff] rounded-lg border-[#DFDFDF]  dark:text-[#A5A5A5] dark:border-gray-600"
                placeholder=" "
                onChange={(e) => statusPageRole(e)}
                value={filterData?.bookingType}
              >
                <option defaultValue value="">
                  {t("BOOKING_TYPE")}
                </option>
                <option value="immediate"> {t("IMMEDIATE")}</option>
                <option value="schedule"> {t("SCHEDULE")}</option>

              </select>
            </span>
            <button
              type="button"
              onClick={handleReset}
              title={t("O_RESET")}
              className="bg-gradientTo flex gap-2 text-sm px-6 ml-3 mb-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
            >
              <BiReset size={18} />
              {t("O_RESET")}
            </button>
          </div>
        </div>

        {/* Table or No Results */}
        {getTabTable(activeTab, requestData, sort, setSort, page, getAllRequest)}

        {paginationObj?.totalItems ? (
          <Pagination
            handlePageClick={handlePageClick}
            options={paginationObj}
            page={page}
          />
        ) : null}
      </div>
    </div>
  );
}



const getTabTable = (tab, filteredData, sort, setSort, page, getAllRequest) => {
  switch (tab) {
    case 'pending':
      return <IncomingTable filteredData={filteredData} sort={sort} setSort={setSort} page={page} />
    case 'ongoing': case 'schedule': case 'accepted':
      return <OngoingTable filteredData={filteredData} sort={sort} setSort={setSort} page={page} tab={tab} type={tab} onComplete={getAllRequest} />
    case 'cancelled':   case 'cancelledByDriver':
      return <RejectedTable filteredData={filteredData} sort={sort} setSort={setSort} page={page} />
    case 'completed':
      return <CompletedTable filteredData={filteredData} sort={sort} setSort={setSort} page={page} />
  }
}


const getSearchPlaceholder = (tab) => {
  switch (tab) {
    case 'pending':
      return 'SEARCH_BY_SERVICE_TYPE'
    case 'ongoing': case 'schedule': case 'cancelled': case 'completed': case 'accepted':case 'cancelledByDriver':
      return 'SEARCH_BY_JOB_ID'

  }
}
